import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

interface IArgs {
  pid: string
  fYear: number
  eltType: EltType
  forceFetch?: boolean
}

export const getFinancialDataForPartnerId = async ({ pid, fYear, eltType, forceFetch }: IArgs) => {
  const url = proxy(`/webservice/590/sp/v3/spJBPELTData/call`)
  const payload = {
    'p.FYear': fYear,
    'p.PartnerId': pid,
    'p.EltType': eltType,
  }

  const [accessToken] = getTokens()
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return response.Rows?.[0] || {}
  } catch (e) {
    Logger.error(e)
    return {}
  }
}
